import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-board-of-directors',
  templateUrl: './board-of-directors.component.html',
  styleUrls: ['./board-of-directors.component.css']
})
export class BoardOfDirectorsComponent implements OnInit {

  //declare variables
	isCollapsed: boolean = false
	showMore1: boolean = false;
	showMore2: boolean = false;
	showMore3: boolean = false;

  //inject services
	constructor() {}

	//initialize the component
	ngOnInit(): void {
		//SEO Optimization
	}

	public toggleMore1() {
		this.showMore1 = true;
	}

	public toggleMore2() {
		this.showMore2 = true;
	}

	public toggleMore3() {
		this.showMore3 = true;
	}

	public showLess1() {
		this.showMore1 = false;
	}

	public showLess2() {
		this.showMore2 = false;
	}

	public showLess3() {
		this.showMore3 = false;
	}

}
